module.exports = __webpack_public_path__ + "static/media/download-gray.faf02a85.svg";